import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { FaqCategoryStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import FaqItemCreate from 'pages/builder/faq_items/faq_item_create';
import FaqItemIndex from 'pages/builder/faq_items/faq_item_index';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';

@observer
class FaqCategoryEdit extends React.Component {

  constructor(props) {
    super(props);
    this.getFaqCategory();
  }
  @autobind getFaqCategory() {
    FaqCategoryStore.getShow({ ids: {faqCategoryId: this.props.params.faqCategoryId }}, this.afterGetShow);
  }

  @autobind afterGetShow(resp) {
    FaqCategoryStore.setShowData(resp);
  }

  render() {
    if (FaqCategoryStore.hasShowData) {
      return (
        <div className='faq-edit'>
          <Link
            to='builder.faq_categories.index'
            style={{margin: '5px 0'}}
          >
            <i className='fa fa-angle-left' style={{marginRight: 4}} />
            FAQ Category List
          </Link>
          <InPlaceText
            legend='Id'
            defaultValue={FaqCategoryStore.showDataField('id')}
            model='faq_categories'
            field='id'
            id={FaqCategoryStore.showDataField('id')}
          />
          <Grid columns={3} gap='sm'>
            <InPlaceText
              legend='Name'
              defaultValue={FaqCategoryStore.showDataField('name')}
              model='faq_categories'
              field='name'
              id={FaqCategoryStore.showDataField('id')}
            />
            <InPlaceText
              legend='Slug'
              defaultValue={FaqCategoryStore.showDataField('slug')}
              model='faq_categories'
              field='slug'
              id={FaqCategoryStore.showDataField('id')}
            />
            <InPlaceText
              legend='Category Group'
              defaultValue={FaqCategoryStore.showDataField('categoryGroup')}
              model='faq_categories'
              field='category_group'
              id={FaqCategoryStore.showDataField('id')}
            />
          </Grid>
          <fieldset>
            <legend>FAQ Items</legend>
            <Stack gap='sm' alignItems='stretch'>
              <FaqItemCreate
                faqCategoryId={FaqCategoryStore.showDataField('id')}
                afterChange={this.getFaqCategory}
              />
              <FaqItemIndex
                faqCategoryId={FaqCategoryStore.showDataField('id')}
                faqItems={FaqCategoryStore.showDataField('faqItems')}
                afterChange={this.getFaqCategory}
              />
            </Stack>
          </fieldset>
        </div>
      );
    }
    return <span />;
  }
}

export default ErrorBoundary(FaqCategoryEdit);
